export default "__VITE_ASSET__CFN2Ob5b__"